import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import Navbar from './Navbar';
import PrivacyPolicySection from './PrivacyPolicySection';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="privacy-page">
      <Navbar />
      <button className="back-button" onClick={() => navigate('/')} aria-label="Go back to home">
        <FaArrowLeft /> Back
      </button>
      
      <div className="privacy-page-content">
        <PrivacyPolicySection />
      </div>
    </div>
  );
}

export default PrivacyPolicy;